import AddressCell from "../elements/table-view/special-cells/AddressCell";
import IconTextCell from "../elements/table-view/special-cells/IconTextCell";
import FilesListCell from "../elements/table-view/special-cells/FilesListCell";
import MultiLabelTextCell from "../elements/table-view/special-cells/MultiLabelTextCell";
import TaskWorkOrderScopeItemActionCell from "../elements/table-view/special-cells/TaskWorkOrderScopeItemActionCell";

export function getMyTasksAndWorkOrdersColumns(type) {
  let columns = [
    { label: "Task", property: type === "tasks" ? "name" : "title" },
    {
      label: "Project & Location",
      property: "projectNameAndContractPlace",
      cellComponent: AddressCell
    },
    {
      label: "Attached Images",
      property: "nestedFiles",
      cellComponent: FilesListCell
    },
    {
      label: "Present",
      property: "presentLabelsAndTexts",
      cellComponent: MultiLabelTextCell
    },
    {
      label: "Status",
      property: "statusWithIcon",
      cellComponent: IconTextCell
    },
    {
      label: "Actions",
      property: type === "tasks" ? "nestedTask" : "nestedWorkOrder",
      cellComponent: TaskWorkOrderScopeItemActionCell
    }
  ];

  if (type === "work-orders") {
    columns = columns.filter(c => {
      return c.label !== "Hours" && c.label !== "Present";
    });
  }

  return columns;
}

export function getScheduledDeliveriesColumns() {
  return [
    {
      label: "PO #",
      property: "id"
    },
    {
      label: "Contract",
      property: "contractName"
    },
    {
      label: "Customer and Location",
      property: "customer",
      cellComponent: AddressCell
    },
    {
      label: "Scheduled",
      property: "scheduled_time"
    },
    {
      label: "Delivered",
      property: "delivered",
      actions: [
        {
          label: "yes",
          clickAction: task => {
            console.log(task);
          }
        },
        {
          label: "no",
          clickAction: task => {
            console.log(task);
          }
        }
      ]
    }
  ];
}

export function getDeliveredProcurementsColumns() {
  return [
    {
      label: "PO #",
      property: "id"
    },
    {
      label: "Contract",
      property: "contractName"
    },
    {
      label: "Customer and Location",
      property: "customer",
      cellComponent: AddressCell
    },
    {
      label: "Scheduled",
      property: "scheduled_time"
    },
    {
      label: "Delivered",
      property: "delivered_time"
    }
  ];
}

export function getCancelledDeliveriesColumns() {
  return [
    {
      label: "PO #",
      property: "id"
    },
    {
      label: "Contract",
      property: "contractName"
    },
    {
      label: "Customer and Location",
      property: "customer",
      cellComponent: AddressCell
    },
    {
      label: "Notes",
      property: "notes"
    }
  ];
}
